exports.components = {
  "component---src-components-page-jsx": () => import("./../../../src/components/Page.jsx" /* webpackChunkName: "component---src-components-page-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-storyblok-preview-jsx": () => import("./../../../src/pages/storyblok-preview.jsx" /* webpackChunkName: "component---src-pages-storyblok-preview-jsx" */)
}

